import { ExtendedWindow } from './window';

function addGTMScript(
  w: ExtendedWindow,
  d: Document,
  s: string,
  l: string,
  i: string,
)
{
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const j = d.createElement(s) as HTMLScriptElement;
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i;
  d.head.appendChild(j);

  // Send afterInteractive event as soon as GTM is initialized and ready to process
  //  This event is needed to kick off all GTM processing in the container
  // Because of WHEN GTM is loaded you are already after interactive in the load() event
  w.dataLayer.push(
    { event: 'afterInteractive' },

    // The page has loaded.... no really....
    {
      event: 'page_loaded',
      page: {
        page_type: document.location.pathname,
        page_location: document.location.href,
        page_title: document.title,
        page_referrer: document.referrer,
        page_path: document.location.pathname,
        //persona: '{{Persona}}', // To be updated with actual user data if applicable - needs confirmed
      },
    },
  );
}

export function initGTM(key: string)
{
  if (key?.length)
  {
    addGTMScript(window, document, 'script', 'dataLayer', key);
  }
}
